import { create } from 'zustand';

export const useVehicleStore = create((set, get) => ({
  // Selected vehicle
  selectedVehicle: null,
  selectedVehicleConversationId: null,
  setSelectedVehicle: (vehicle) => set({ 
    selectedVehicle: vehicle,
    selectedVehicleConversationId: vehicle?.conversation_id || null
  }),
  clearSelectedVehicle: () => set({ 
    selectedVehicle: null, 
    selectedVehicleConversationId: null 
  }),
  setSelectedVehicleConversationId: (id) => set({ selectedVehicleConversationId: id }),
  
  // Vehicle context
  vehicleContext: null,
  setVehicleContext: (context) => set({ vehicleContext: context }),
  clearVehicleContext: () => set({ vehicleContext: null }),
}));


